import { useState, useEffect } from 'react';
import NavBar from '../Common/NavBar/NavBar';
import SideBar from '../Common/SideBar/SideBar';
import Grid from '../Common/Grid/Grid';
import { Button, Input, Upload, Modal, Form } from 'antd';
import {
  getAllCategories,
  addCategory,
  activateAdhkarCategory,
  deactivateAdhkarCategory,
  editAzkarCategory
} from '../../Network/Network';
import { toastError, toastSuccess } from '../../Helpers/toasters';
import { baseUrl } from '../../Network/Services';

function AdhkarCategoriesScreen() {
  const [tableLoading, setTableLoading] = useState(true);
  const [dataSource, setDataSource] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editingCategory, setEditingCategory] = useState(null);
  const [form] = Form.useForm();
  const [editForm] = Form.useForm();

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = () => {
    setTableLoading(true);
    getAllCategories(
      (success) => {
        if (success?.isSuccess) {
          setDataSource(success.data);
        } else {
          toastError('فشل تحميل التصنيفات');
        }
        setTableLoading(false);
      },
      () => {
        toastError('حدث خطأ أثناء تحميل التصنيفات');
        setTableLoading(false);
      }
    );
  };

  const handleAddCategory = (values) => {
    const { name, image, nameEn } = values;
    if (!image || image.length === 0) {
      toastError('يرجى اختيار صورة');
      return;
    }

    const formData = new FormData();
    formData.append('name', name);
    formData.append('nameEn', nameEn);

    formData.append('image', image[0].originFileObj);

    addCategory(
      formData,
      (res) => {
        if (res?.isSuccess) {
          toastSuccess('تمت إضافة التصنيف بنجاح');
          setIsModalOpen(false);
          form.resetFields();
          fetchCategories();
        } else {
          toastError('فشل في إضافة التصنيف');
        }
      },
      () => {
        toastError('حدث خطأ أثناء إضافة التصنيف');
      }
    );
  };

  const handleToggleStatus = (record) => {
    const apiCall = record.isActive ? deactivateAdhkarCategory : activateAdhkarCategory;
    apiCall(
      { categoryId: record._id },
      (res) => {
        if (res?.isSuccess) {
          toastSuccess('تم تحديث الحالة بنجاح');
          fetchCategories();
        } else {
          toastError('فشل في تحديث الحالة');
        }
      },
      () => toastError('حدث خطأ أثناء تحديث الحالة')
    );
  };

  const handleEditCategory = (values) => {
    const { name, image, nameEn } = values;
    const formData = new FormData();
    formData.append('name', name);
    formData.append('nameEn', nameEn);

    if (image && image.length > 0) {
      formData.append('image', image[0].originFileObj);
    }
    formData.append('categoryId', editingCategory._id);

    editAzkarCategory(
      formData,
      (res) => {
        if (res?.isSuccess) {
          toastSuccess('تم تعديل التصنيف بنجاح');
          setIsEditModalOpen(false);
          editForm.resetFields();
          setEditingCategory(null);
          fetchCategories();
        } else {
          toastError('فشل في تعديل التصنيف');
        }
      },
      () => {
        toastError('حدث خطأ أثناء تعديل التصنيف');
      }
    );
  };

  const columns = [
    {
      title: 'التصنيف',
      dataIndex: 'name',
      key: 'name',
      sorter: (a, b) => a.name.localeCompare(b.name)
    },
    {
      title: 'التصنيف بالانجليزيه',
      dataIndex: 'nameEn',
      key: 'nameEn',
      sorter: (a, b) => a.nameEn.localeCompare(b.name)
    },
    {
      title: 'الصورة',
      dataIndex: 'image',
      key: 'image',
      render: (text) => (
        <img
          src={`${baseUrl}${text?.replace(/\\/g, '/')}`}
          alt="category"
          style={{ width: 60, height: 60, objectFit: 'cover' }}
        />
      )
    },
    {
      title: 'الحالة',
      dataIndex: 'isActive',
      key: 'isActive',
      render: (isActive) => (isActive ? 'مفعل' : 'معطل')
    },
    {
      title: 'الإجراءات',
      key: 'action',
      render: (_, record) => (
        <>
          <Button type="link" onClick={() => handleToggleStatus(record)}>
            {record.isActive ? 'تعطيل' : 'تفعيل'}
          </Button>
          <Button
            type="link"
            onClick={() => {
              setEditingCategory(record);
              setIsEditModalOpen(true);
              editForm.setFieldsValue({
                name: record.name,
                image: []
              });
            }}
          >
            تعديل
          </Button>
        </>
      )
    }
  ];

  const filteredData = dataSource.filter((item) =>
    item.name.toLowerCase().includes(searchValue.toLowerCase())
  );

  return (
    <div className="d-flex">
      <SideBar parent={'adhkarCategories'} />
      <div className="flex-1 section">
        <NavBar
          getSearchedValue={(value) => {
            setSearchValue(value);
          }}
        />

        <h2 style={{ fontSize: '20px', fontWeight: 'bold', marginBottom: 10 }}>
          تصنيفات الأذكار
        </h2>

        <Button
          type="primary"
          onClick={() => setIsModalOpen(true)}
          style={{ marginBottom: 20 }}
        >
          + إضافة تصنيف جديد
        </Button>

        <Grid
          columns={columns}
          dataSource={filteredData}
          loading={tableLoading}
          rowKey={'_id'}
          options={true}
          exportMe={false}
          emptyTableText={{
            emptyText: 'لا توجد تصنيفات'
          }}
        />

        {/* ✅ Add Modal */}
        <Modal
          title={
            <div style={{ textAlign: 'left', fontWeight: 'bold' }}>إضافة تصنيف جديد</div>
          }
          visible={isModalOpen}
          onCancel={() => setIsModalOpen(false)}
          footer={null}
          destroyOnClose
        >
          <Form
            form={form}
            layout="vertical"
            onFinish={handleAddCategory}
            style={{ direction: 'rtl', textAlign: 'right' }}
          >
            <Form.Item
              name="name"
              label="اسم التصنيف"
              rules={[{ required: true, message: 'يرجى إدخال اسم التصنيف' }]}
            >
              <Input placeholder="أدخل اسم التصنيف" />
            </Form.Item>
            <Form.Item
              name="nameEn"
              label="اسم التصنيف بالانجليزيه"
              rules={[{ required: true, message: ' يرجى إدخال اسم التصنيف بالانجليزيه' }]}
            >
              <Input placeholder="أدخل اسم التصنيف بالانجليزيه" />
            </Form.Item>

            <Form.Item
              name="image"
              label="الصورة"
              valuePropName="fileList"
              getValueFromEvent={(e) => (Array.isArray(e) ? e : e.fileList)}
              rules={[{ required: true, message: 'يرجى رفع صورة' }]}
            >
              <Upload listType="picture-card" beforeUpload={() => false}>
                + اختر صورة
              </Upload>
            </Form.Item>

            <Button type="primary" htmlType="submit" block>
              إضافة
            </Button>
          </Form>
        </Modal>

        {/* ✅ Edit Modal */}
        <Modal
          title={
            <div style={{ textAlign: 'left', fontWeight: 'bold' }}>تعديل التصنيف</div>
          }
          visible={isEditModalOpen}
          onCancel={() => {
            setIsEditModalOpen(false);
            setEditingCategory(null);
          }}
          footer={null}
          destroyOnClose
        >
          <Form
            form={editForm}
            layout="vertical"
            onFinish={handleEditCategory}
            style={{ direction: 'rtl', textAlign: 'right' }}
          >
            <Form.Item
              name="name"
              label="اسم التصنيف"
              rules={[{ required: true, message: 'يرجى إدخال اسم التصنيف' }]}
            >
              <Input placeholder="أدخل اسم التصنيف" />
            </Form.Item>
            <Form.Item
              name="nameEn"
              label="اسم التصنيف بالانجليزيه"
              rules={[{ required: true, message: ' يرجى إدخال اسم التصنيف بالانجليزيه' }]}
            >
              <Input placeholder="أدخل اسم التصنيف بالانجليزيه" />
            </Form.Item>

            <Form.Item
              name="image"
              label="الصورة (اختياري)"
              valuePropName="fileList"
              getValueFromEvent={(e) => (Array.isArray(e) ? e : e.fileList)}
            >
              <Upload listType="picture-card" beforeUpload={() => false}>
                + اختر صورة جديدة
              </Upload>
            </Form.Item>

            <Button type="primary" htmlType="submit" block>
              حفظ التعديلات
            </Button>
          </Form>
        </Modal>
      </div>
    </div>
  );
}

export default AdhkarCategoriesScreen;
